import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWifiFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWifiFull"><Path d="M21 7.57177C15.751 3.47477 8.249 3.47477 3 7.57177M6.75098 13.3144C9.81298 10.9264 14.188 10.9264 17.25 13.3144" stroke="currentColor" strokeLinejoin="round"/><Path d="M12 18.625C12.3452 18.625 12.625 18.9048 12.625 19.25C12.625 19.5952 12.3452 19.875 12 19.875C11.6548 19.875 11.375 19.5952 11.375 19.25C11.375 18.9048 11.6548 18.625 12 18.625Z" fill="currentColor" stroke="currentColor" strokeWidth="0.25"/></CentralIconBase>;
});

export default IconWifiFull;
